// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"be2ee538","312":"3126180e"}[chunkId] + ".chunk.js";
};